<template>
  <div id="individual-layout">
    <ToLoginDialog ref="toLoginDialog"></ToLoginDialog>
    <Header></Header>
    <div class="body">
      <section class="body-left">
        <div class="avatar-box">
          <el-image
            fit="cover"
            :src="individualAccountDetail.avatar&&individualAccountDetail.avatar.link?individualAccountDetail.avatar.link:'../assets/img/talent-img.png'"
            class="avatar-img u-m-b-20"
            @click="handleAvatar"
          ></el-image>
          <strong class="u-font-16">{{userInfo.account}}</strong>
        </div>
        <div class="menu-box">
          <router-link v-for="item in menus" :key="item.id" :to="item.url" class="menu-link" :class="{ active: $route.path === item.url }">
            <i :class="item.icon" class="icon u-m-r-10"></i>
            <span>{{ item.name }}</span>
          </router-link>
        </div>
      </section>
      <section class="body-right">
        <router-view></router-view>
      </section>
    </div>
    <EditAvatar ref="editAvatar" type="company" @loadAvatar="loadDetail" />
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import EditAvatar from '@/components/EditAvatar'
import Footer from '@/components/Footer'
import ToLoginDialog from '@/components/ToLoginDialog'
import { mapGetters, mapActions } from 'vuex'
// import { individualDetailUrl } from '@/api'
export default {
  name: 'individual-layout',
  components: {
    Header,
    EditAvatar,
    Footer,
    ToLoginDialog
  },
  mounted() {
    // this.loadDetail()
  },
  data() {
    return {
      detail: {},
      menus: [
        { name: '个人信息', url: '/individual/individualInfo', icon: 'iconfont icon-gerenxinxi' },
        { name: '我的简历', url: '/individual/myResume', icon: 'iconfont icon-wodejianli' },
        { name: '投递记录', url: '/individual/deliveryRecord', icon: 'iconfont icon-toudijilu' },
        { name: '我的收藏', url: '/individual/myFavorite', icon: 'iconfont icon-wodeshoucang' },
        { name: '谁看过我', url: '/individual/whoSeenMe', icon: 'iconfont icon-liulan' }
      ]
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'individualAccountDetail'])
  },
  methods: {
    ...mapActions(['SetIndividualAccountDetail']),
    // 获取个人详情
    loadDetail() {
      this.SetIndividualAccountDetail()
      // const { data } = await this.$get(individualDetailUrl)
      // this.detail = data
    },

    // 点击上传头像
    handleAvatar() {
      this.$refs.editAvatar.open({ avatar: this.individualAccountDetail.avatar.id, avatarUrl: this.individualAccountDetail.avatar.link })
    }
  }
}
</script>

<style lang="scss">
#individual-layout {
  min-width: 1200px;
  height: 100vh;
  padding: 80px 0 0 0;
  position: relative;
  .body {
    width: 1200px;
    height: calc(100vh - 120px);
    margin: 20px auto;
    display: flex;
  }
  .body-left {
    width: 240px;
    height: 100%;
    background-color: #fff;
    margin-right: 20px;
  }
  .avatar-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    .avatar-img {
      cursor: pointer;
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    .verify-btn {
      color: #999;
      width: 100px;
      height: 30px;
      font-size: 14px;
      margin-top: 20px;
      border: 1px solid #cecece;
      border-radius: 4px;
      background: #f5f5f5;
      .verify-status {
        margin-left: 5px;
      }
    }
    .unverified {
      background: #f5f5f5;
      border-color: #cecece;
      color: #999;
    }

    .verifying {
      background: rgba(255, 107, 1, 0.1);
      border-color: #ff6b01;
      color: #ff6b01;
    }
    .verified {
      background: rgba(0, 174, 78, 0.1);
      border-color: #00ae4e;
      color: #00ae4e;
    }
    .verifyFail {
      background: #ffebeb;
      border-color: #ff3636;
      color: #ff3636;
    }
  }
  .menu-link {
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 30px;
    border-right: 6px solid transparent;
    font-size: 16px;
    &:hover {
      color: $primary-color;
      .icon {
        color: $primary-color;
      }
    }
    &.active {
      .icon {
        color: $primary-color;
      }
      color: $primary-color;
      border-right: 6px solid $primary-color;
      background-color: #ffede0;
    }
    .icon {
      color: #999;
    }
  }
  .body-right {
    flex: 1;
    height: 100%;
    overflow-y: auto;
    background-color: #fff;
  }
}
</style>
